import React, { PureComponent } from 'react';
import { bool, object, string } from 'prop-types';
import { Provider as StoreProvider } from 'react-redux';
import { PAGE_NAME } from '../../shared/constants';
import { EventTypes } from '../../../../shared/utils/events/types';
import Entry from '../../../../shared/components/Entry';
import Items from '../Items';
import Header from '../Header';
import createCollectionPageStore from '../../store';

import './style.scss';

class CollectionPage extends PureComponent {
    constructor(props) {
        super(props);

        const { collectionData, gigsData, sellersData } = props;

        this.store = createCollectionPageStore({
            collectionData,
            gigsData,
            sellersData,
        });
    }

    render() {
        const { collectionData, currency, businessId, isTouch, rollouts } = this.props;
        const { creator } = collectionData;

        return (
            <StoreProvider store={this.store}>
                <Entry
                    className="collection-page"
                    creator={creator}
                    currency={currency}
                    businessId={businessId}
                    isTouch={isTouch}
                    rollouts={rollouts}
                    pageName={PAGE_NAME}
                    eventsRoot={EventTypes.collectionPage}
                >
                    <Header />
                    <Items />
                </Entry>
            </StoreProvider>
        );
    }
}

CollectionPage.propTypes = {
    collectionData: object,
    gigsData: object,
    sellersData: object,
    currency: object,
    businessId: string,
    rollouts: object,
    isTouch: bool,
};

CollectionPage.defaultProps = {
    collectionData: {},
    gigsData: {},
    sellersData: {},
    rollouts: {},
};

export default CollectionPage;
